import React from 'react';

// External AskSmart Terms & Conditions page — opened in a new tab for every org
// except CaddieGames.
const ASKSMART_TERMS_URL = 'https://asksmart.ai/terms-conditions/';

// CaddieGames Terms & Conditions document, served as a static asset from /public.
// Clicking the link downloads this file instead of navigating away.
const CADDIEGAMES_TERMS_DOC = `${process.env.PUBLIC_URL}/CaddieGames T&C.pdf`;

interface TermsAndConditionsLinkProps {
  /** When true, the org being registered for is CaddieGames. */
  isCaddieGames: boolean;
}

/**
 * The "Terms and Conditions" link shown next to the registration consent
 * checkbox. CaddieGames registrations download the CaddieGames T&C document;
 * everyone else opens the AskSmart T&C page in a new tab.
 *
 * The link sits inside the consent `<label>`, so the click is stopped from
 * propagating — otherwise opening the link would also toggle the checkbox.
 */
export default function TermsAndConditionsLink({ isCaddieGames }: TermsAndConditionsLinkProps) {
  const stopToggle = (e: React.MouseEvent) => e.stopPropagation();

  if (isCaddieGames) {
    return (
      <a className="terms-link" href={CADDIEGAMES_TERMS_DOC} download onClick={stopToggle}>
        Terms and Conditions
      </a>
    );
  }

  return (
    <a
      className="terms-link"
      href={ASKSMART_TERMS_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={stopToggle}
    >
      Terms and Conditions
    </a>
  );
}
